const nightTimes: string[] = [
  "10PM",
  "1AM",
  "4AM",
  "11PM",
  "9PM",
  "2AM",
  "3AM",
  "0AM",
];

export default nightTimes;
